"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcInvoiceLines = class UcInvoiceLines extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    onProductSelected(...args) {
        let [row, product] = args;
        this.invoiceLineHelper.onProductSelected(row, product);
        row.setFocus('quantity');
    }
    hasQuantityMismatch(...args) {
        const row = args[0];
        return row.accountings
            && row.accountings.data
            && row.accountings.data.length
            && _.sumBy(row.accountings.data, p => p.quantity) != row.quantity;
    }
    getInvoiceLineEditorIsDisabled(...args) {
        const [row] = args;
        return !row.tax_code;
    }
    onRentalOrPropertySelected(...args) {
        let [row, selection] = args;
        console.log(row, selection);
        if (!selection) {
            row.rental = null;
            row.property = null;
            return;
        }
        if (_.isObject(selection) && selection.object == 'rental') {
            row.rental = selection;
            row.property = null;
            return;
        }
        if (_.isObject(selection) && ['property', 'property_unit'].indexOf(selection.object) > -1) {
            row.rental = null;
            row.property = selection;
            return;
        }
    }
    invoice;
    onInvoice(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoice");
    }
    currency;
    onCurrency(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("currency");
    }
    defaultDiscount;
    onDefault_discount(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("defaultDiscount");
    }
    defaultTaxCode;
    onDefault_tax_code(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("defaultTaxCode");
    }
    formContext;
    onForm_context(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("formContext");
    }
    expenseTypes;
    async $$load_expenseTypes() {
        return this.$app.repo.get('list_object_by_type', { parameters: { object_type: 'expense-type' } });
    }
    taxCodes;
    async $$load_taxCodes() {
        return this.$app.repo.get('list_tax_code');
    }
    currencies;
    async $$load_currencies() {
        return this.$app.repo.get('list_currency');
    }
    units;
    async $$load_units() {
        return this.$app.repo.get('list_unit');
    }
    displayAddInvoiceLine;
    messages;
    invoiceLineHelper;
    async $$load_invoiceLineHelper() {
        return new this.$app.helpers.InvoiceLineHelper(this.invoice, this.$data.currencies, this.$data.taxCodes);
    }
    ux;
    b_5962862420439144_rowHeader;
    b_5962862420439144_paging;
    b_5962862420439144_sortable;
    b_5962862420439144_rowTemplate;
    async $$load_b_5962862420439144_rowTemplate() {
        return {
            description: null,
            discount: this.defaultDiscount || 0,
            notes: null,
        };
    }
    b_5962862420439144_messages;
    b_5962862420439144_columns;
    async $$load_b_5962862420439144_columns() {
        return [{
                name: "product",
                header: this.$fn.gettext("Product"),
                width: "250px",
                required: true,
                textAlign: "left",
                editor: {
                    name: "template",
                    value: "<ItpSelect2\n\
  class=\"w-100\"\n\
  v-model=\"currentValue\"\n\
  bindObject\n\
  valueField=\"id\"\n\
  textField=\"name\"\n\
  required\n\
  :placeholder=\"messages.msgSearchProduct\"\n\
  :options=\"globs.searchDataSource('suggest_product', {invoice_line_products: 'include'})\"\n\
  :autofocus=autofocus\n\
  :form=\"formId\"\n\
  :inputId=\"col.field\"\n\
  :size=\"col.size\"\n\
  :state=\"validationState\"\n\
  :disabled=\"isDisabled\"\n\
  :tabindex=\"col.tabindex\"\n\
  taggable\n\
  @optionSelected=\"col.emit('product:selected', {col, row, ...$event})\"\n\
  @change=\"onChange($event)\"\n\
>\n\
  <template #search=\"{attributes, events}\">\n\
    <input\n\
      class=\"vs__search\"\n\
      v-bind=\"attributes\"\n\
      v-on=\"events\"\n\
    />\n\
  </template>\n\
\n\
  <template #option=\"option\">\n\
    <UcSuggestProductOption :option=\"option\" v-if=\"option.object=='product'\">\n\
    </UcSuggestProductOption>\n\
    <span v-else>{{ option.name }}</span>\n\
  </template>\n\
\n\
  <template #selected-option=\"option\">\n\
    <UcSuggestProductOption :option=\"option\" v-if=\"option.object=='product'\">\n\
    </UcSuggestProductOption>\n\
    <span v-else>{{ option.name }}</span>\n\
  </template>\n\
\n\
  <template #list-footer>\n\
    <hr />\n\
    <ItpButton\n\
      class=\"ml-2\"\n\
      size=sm\n\
      variant=light\n\
      @click=\"col.emitCellEvent('createProduct', row)\">\n\
      {{ messages.msgCreateProduct }}\n\
    </ItpButton>\n\
  </template>\n\
\n\
  <template #footer>\n\
    <b-form-input\n\
      class=\"mt-1\"\n\
      type=text\n\
      v-model=row.description\n\
      id=\"description\"\n\
      name=\"description\"\n\
      autocomplete=\"off\"\n\
      :form=\"formId\"\n\
      :size=col.size\n\
      :disabled=\"isDisabled\"\n\
      :placeholder=\"globs.messages.invoiceLineDescriptionPlaceholder\"\n\
      @change=\"onFieldChange('description', row.description)\"\n\
    ></b-form-input>\n\
  </template>\n\
</ItpSelect2>\n\
",
                },
                formatter: {
                    name: "template",
                    value: "<div class=\"text-truncate\" :title=\"row.description\">\n\
  <b-link v-if=\"row.product\" :to=\"{\n\
    name: 'app.product',\n\
    params: { id: row.product.id }\n\
  }\">{{ row.description }}</b-link>\n\
  <span v-if=\"!row.product\">\n\
    {{ row.description }}\n\
  </span>\n\
</div>\n\
",
                },
            },
            {
                name: "advance",
                header: this.$fn.pgettext("InvoiceLine|ColHeader", "Adv."),
                headerTooltip: this.$fn.pgettext("invoiceLine|ColHeader|Tooltip", "Advance"),
                headerTextAlign: "center",
                width: "25px",
                type: "checkbox",
                editorIsDisabled: this.getInvoiceLineEditorIsDisabled,
            },
            {
                name: "intermediated_service",
                header: this.$fn.pgettext("AbbrIntermediatedService", "IMS"),
                headerTooltip: this.$fn.gettext("Intermediated Service"),
                headerTextAlign: "center",
                width: "25px",
                type: "checkbox",
                editorIsDisabled: this.getInvoiceLineEditorIsDisabled,
            },
            {
                name: "quantity",
                type: "number",
                maxAllowedDecimals: this.isIncomingInvoice ? null : this.currency.quantity_digits,
                default: 0,
                header: this.$fn.pgettext("Quantity Abbr", "Qty"),
                headerTooltip: this.$fn.gettext("Quantity"),
                headerTextAlign: "right",
                width: "60px",
                textAlign: "right",
                required: true,
                editorIsDisabled: this.getInvoiceLineEditorIsDisabled,
            },
            {
                name: "unit",
                header: this.$fn.pgettext("Unit Abbr", "Unit"),
                headerTooltip: this.$fn.gettext("Unit"),
                width: "70px",
                textAlign: "center",
                headerTextAlign: "center",
                required: true,
                editorIsDisabled: this.getInvoiceLineEditorIsDisabled,
            },
            {
                name: "price",
                type: "number",
                maxAllowedDecimals: this.isIncomingInvoice ? null : this.currency.price_digits,
                default: 0,
                header: this.$fn.gettext("Price"),
                width: "70px",
                textAlign: "right",
                headerTextAlign: "right",
                required: true,
                editorIsDisabled: this.getInvoiceLineEditorIsDisabled,
                footerTotals: rows => _.meanBy(rows, p => p.quantity * p.price),
            },
            {
                name: "discount",
                type: "number",
                maxAllowedDecimals: this.isIncomingInvoice ? null : this.currency.digits,
                default: this.defaultDiscount || 0,
                header: this.$fn.pgettext("AbbrDiscount", "Disc"),
                headerTooltip: this.$fn.gettext("Discount"),
                noFooterTotals: true,
                width: "50px",
                textAlign: "right",
                headerTextAlign: "right",
                required: true,
                editorIsDisabled: this.getInvoiceLineEditorIsDisabled,
            },
            {
                name: "net_amount",
                type: "number",
                maxAllowedDecimals: this.currency.digits,
                default: 0,
                header: this.$fn.gettext("Net"),
                width: "95px",
                textAlign: "right",
                headerTextAlign: "right",
                required: true,
                editorIsDisabled: this.getInvoiceLineEditorIsDisabled,
            },
            {
                name: "amount",
                type: "number",
                maxAllowedDecimals: this.currency.digits,
                default: 0,
                header: this.$fn.gettext("Amount"),
                width: "95px",
                textAlign: "right",
                headerTextAlign: "right",
                required: true,
                editorIsDisabled: this.getInvoiceLineEditorIsDisabled,
            },
            {
                name: "tax_code",
                header: this.$fn.gettext("VAT"),
                headerTooltip: this.$fn.gettext("VAT Code"),
                width: "80px",
                type: "select",
                options: this.taxCodes,
                valueField: "id",
                textField: "id",
                textAlign: "right",
                headerTextAlign: "right",
                editorIsDisabled: this.getInvoiceLineEditorIsDisabled,
            },
            {
                name: "deductible_vat_amount",
                type: "number",
                disabled: this.isOutgoingInvoice,
                header: this.$fn.gettext("D-VAT"),
                headerTooltip: this.$fn.gettext("Deductible VAT amount"),
                maxAllowedDecimals: this.currency.digits,
                default: 0,
                width: "95px",
                textAlign: "right",
                headerTextAlign: "right",
                editorIsDisabled: this.getInvoiceLineEditorIsDisabled,
            },
            {
                name: "expense_type",
                type: "select",
                header: this.$fn.pgettext("InvoiceLine|ColHeader", "Expense Type"),
                width: "100px",
                options: this.expenseTypes,
                valueField: "name",
                textField: "name",
            },
            {
                name: "rental_or_property",
                header: this.$fn.gettext("Cost Center"),
                textAlign: "left",
                width: "100px",
                editor: {
                    name: "template",
                    value: "<ItpSelect2\n\
  class=\"w-100\"\n\
  v-model=\"currentValue\"\n\
  bindObject\n\
  valueField=\"id\"\n\
  textField=\"name\"\n\
  required\n\
  :placeholder=\"messages.msgSearchCostCenter\"\n\
  :options=\"globs.searchDataSource('suggest_cost_center')\"\n\
  :initialOptions=\"[row.rental || row.property]\"\n\
  :form=\"formId\"\n\
  :inputId=\"col.field\"\n\
  :size=\"col.size\"\n\
  :state=\"validationState\"\n\
  :disabled=\"isDisabled\"\n\
  :tabindex=\"col.tabindex\"\n\
  @optionSelected=\"col.emit('rental_or_property:selected', {col, row, ...$event})\"\n\
  @change=\"onChange($event)\"\n\
>\n\
  <template #search=\"{attributes, events}\">\n\
    <input\n\
      class=\"vs__search\"\n\
      v-bind=\"attributes\"\n\
      v-on=\"events\"\n\
    />\n\
  </template>\n\
\n\
  <template #option=\"option\">\n\
    <UcSuggestRentalOption :option=\"option\" v-if=\"option.object=='rental'\">\n\
    </UcSuggestRentalOption>\n\
    <UcSuggestPropertyOption :option=\"option\" v-if=\"option.object=='property' || option.object == 'property_unit'\">\n\
    </UcSuggestPropertyOption>\n\
  </template>\n\
\n\
  <template #selected-option=\"option\">\n\
    <UcSuggestRentalOption :option=\"option\" v-if=\"option.object=='rental'\">\n\
    </UcSuggestRentalOption>\n\
    <UcSuggestPropertyOption :option=\"option\" v-if=\"option.object=='property' || option.object == 'property_unit'\">\n\
    </UcSuggestPropertyOption>\n\
  </template>\n\
</ItpSelect2>\n\
",
                },
                formatter: {
                    name: "template",
                    value: "<div>\n\
  <UcSuggestRentalOption :option=\"row.rental\" v-if=\"row.rental\">\n\
  </UcSuggestRentalOption>\n\
  <UcSuggestPropertyOption :option=\"row.property\" v-if=\"row.property\" display-code>\n\
  </UcSuggestPropertyOption>\n\
</div>\n\
",
                },
            },
        ];
    }
    b_1270943406604881_dataSource;
    async $$load_b_1270943406604881_dataSource() {
        return {
            name: "suggest_invoice",
            parameters: {
                invoice_kind: this.invoice.invoice_kind,
                client_id: this.invoice.client.id,
                company_id: this.invoice.company.id,
                exclude_invoice: this.invoice.id,
            },
        };
    }
    b_1803307708030275_paging;
    b_1803307708030275_sortable;
    b_1803307708030275_rowHeader;
    b_1803307708030275_fillEmptyRowSpace;
    b_1803307708030275_messages;
    b_1803307708030275_columns;
    async $$load_b_1803307708030275_columns() {
        return [{
                name: "meter",
                header: this.$fn.gettext("Meter"),
                width: "160px",
                required: true,
                type: "select2",
                options: this.$fn.searchDataSource('suggest_meter'),
                bindObject: true,
                valueField: "id",
                textField: "serial_number",
                formatter: {
                    name: "template",
                    value: "<UcMeterMiniCard :item=\"row.meter\" link-style-underline no-strong></UcMeterMiniCard>\n\
",
                },
            },
            {
                name: "from",
                header: this.$fn.gettext("Previous reading"),
                width: "160px",
                formatter: {
                    name: "template",
                    value: "<div>{{ row.from_date|date }} {{ row.from_amount|number }} {{ row.from_unit }}</div>\n\
",
                },
                editor: {
                    name: "template",
                    value: "<div class=\"input-group\">\n\
  <ItpFormDatetime\n\
    v-model=\"row.from_date\"\n\
    name=\"from_date\"\n\
    placeholder=\"date\"\n\
    size=\"sm\"\n\
    style=\"min-width:100px;\"\n\
    required\n\
  ></ItpFormDatetime>\n\
\n\
  <ItpFormInput\n\
    type=\"number\"\n\
    name=\"from_amount\"\n\
    v-model=\"row.from_amount\"\n\
    placeholder=\"reading\"\n\
    size=\"sm\"\n\
    style=\"min-width:60px;\"\n\
    required\n\
  ></ItpFormInput>\n\
\n\
  <ItpFormSelect\n\
    v-model=\"row.from_unit\"\n\
    name=\"from_unit\"\n\
    placeholder=\"unit\"\n\
    size=\"sm\"\n\
    :options=\"globs.units\"\n\
    style=\"min-width:60px;\"\n\
    valueField=\"symbol\"\n\
    textField=\"symbol\"\n\
    required\n\
  ></ItpFormSelect>\n\
</div>\n\
",
                },
            },
            {
                name: "to",
                header: this.$fn.gettext("Current reading"),
                width: "240px",
                formatter: {
                    name: "template",
                    value: "<div>{{ row.to_date|date }} {{ row.to_amount|number }} {{ row.to_unit }}</div>\n\
",
                },
                editor: {
                    name: "template",
                    value: "<div class=\"input-group\">\n\
  <ItpFormDatetime\n\
    v-model=\"row.to_date\"\n\
    name=\"to_date\"\n\
    placeholder=\"date\"\n\
    size=\"sm\"\n\
    style=\"min-width:100px;\"\n\
    required\n\
  ></ItpFormDatetime>\n\
\n\
  <ItpFormInput\n\
    type=\"number\"\n\
    name=\"to_amount\"\n\
    v-model=\"row.to_amount\"\n\
    placeholder=\"reading\"\n\
    size=\"sm\"\n\
    style=\"min-width:60px;\"\n\
    required\n\
  ></ItpFormInput>\n\
\n\
  <ItpFormSelect\n\
    v-model=\"row.to_unit\"\n\
    name=\"to_unit\"\n\
    placeholder=\"unit\"\n\
    size=\"sm\"\n\
    :options=\"globs.units\"\n\
    style=\"min-width:60px;\"\n\
    valueField=\"symbol\"\n\
    textField=\"symbol\"\n\
    required\n\
  ></ItpFormSelect>\n\
</div>\n\
",
                },
            },
            {
                name: "consumption",
                header: this.$fn.gettext("Consumption"),
                readonly: true,
                formatter: {
                    name: "template",
                    value: "<div>{{ row.consumption_amount|number }} {{ row.consumption_unit }}</div>\n\
",
                },
            },
            {
                name: "billing_multiplier",
                header: this.$fn.gettext("Multiplier"),
                default: 1,
                width: "70px",
                type: "number",
                required: true,
            },
        ];
    }
    b_7700024326226090_paging;
    b_7700024326226090_sortable;
    b_7700024326226090_rowHeader;
    b_7700024326226090_fillEmptyRowSpace;
    b_7700024326226090_messages;
    b_7700024326226090_columns;
    async $$load_b_7700024326226090_columns() {
        return [{
                name: "expense_type",
                type: "select",
                header: this.$fn.gettext("Expense Type"),
                width: "100px",
                options: this.expenseTypes,
                valueField: "name",
                textField: "name",
            },
            {
                name: "rental",
                type: "select2",
                header: this.$fn.gettext("Rental"),
                width: "100px",
                path: "name",
                bindObject: true,
                textField: "name",
                options: this.$fn.searchDataSource('suggest_rental'),
                useOptionTemplateForSelectedOption: true,
                optionTemplate: "<UcSuggestRentalOption :option=\"option\"></UcSuggestRentalOption>",
            },
            {
                name: "property",
                type: "select2",
                header: this.$fn.gettext("Property"),
                width: "100px",
                path: "name",
                bindObject: true,
                textField: "name",
                options: this.$fn.searchDataSource('suggest_property'),
                useOptionTemplateForSelectedOption: true,
                optionTemplate: "<UcSuggestPropertyOption :option=\"option\"></UcSuggestPropertyOption>",
            },
            {
                name: "contractor",
                type: "select2",
                header: this.$fn.gettext("Contractor"),
                width: "100px",
                path: "name",
                bindObject: true,
                textField: "name",
                options: this.$fn.searchDataSource('suggest_company', { 'role': 'partner', 'is-contractor': true }),
            },
            {
                name: "quantity",
                type: "number",
                header: this.$fn.gettext("Quantity"),
                width: "100px",
            },
        ];
    }
    dataMembers = ['expenseTypes', 'taxCodes', 'currencies', 'units', 'displayAddInvoiceLine', 'messages', 'invoiceLineHelper', 'ux', 'b_5962862420439144_rowHeader', 'b_5962862420439144_paging', 'b_5962862420439144_sortable', 'b_5962862420439144_rowTemplate', 'b_5962862420439144_messages', 'b_5962862420439144_columns', 'b_1270943406604881_dataSource', 'b_1803307708030275_paging', 'b_1803307708030275_sortable', 'b_1803307708030275_rowHeader', 'b_1803307708030275_fillEmptyRowSpace', 'b_1803307708030275_messages', 'b_1803307708030275_columns', 'b_7700024326226090_paging', 'b_7700024326226090_sortable', 'b_7700024326226090_rowHeader', 'b_7700024326226090_fillEmptyRowSpace', 'b_7700024326226090_messages', 'b_7700024326226090_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                expenseTypes: null,
                taxCodes: null,
                currencies: null,
                units: null,
                displayAddInvoiceLine: null,
                messages: {
                    invoiceLineProductSearchPlaceholder: this.$fn.pgettext("InvoiceLines", "Search product/service..."),
                    invoiceLineCostCenterSearchPlaceholder: this.$fn.pgettext("invoiceLines", "search..."),
                    invoiceLineDescriptionPlaceholder: this.$fn.pgettext("InvoiceLines", "Description"),
                },
                invoiceLineHelper: null,
                ux: null,
                b_5962862420439144_rowHeader: false,
                b_5962862420439144_paging: false,
                b_5962862420439144_sortable: false,
                b_5962862420439144_rowTemplate: null,
                b_5962862420439144_messages: {
                    msgCreateRow: this.$fn.pgettext("InvoiceLines", "Add line"),
                    msgCreateProduct: this.$fn.pgettext("InvoiceLines", "Add new product..."),
                    msgSearchProduct: this.$fn.pgettext("InvoiceLines", "Search for product/service..."),
                    msgSearchCostCenter: this.$fn.pgettext("InvoiceLines", "search..."),
                },
                b_5962862420439144_columns: null,
                b_1270943406604881_dataSource: null,
                b_1803307708030275_paging: false,
                b_1803307708030275_sortable: false,
                b_1803307708030275_rowHeader: false,
                b_1803307708030275_fillEmptyRowSpace: false,
                b_1803307708030275_messages: {
                    msgCreateRow: this.$fn.pgettext("invoiceLines", "New meter row"),
                },
                b_1803307708030275_columns: null,
                b_7700024326226090_paging: false,
                b_7700024326226090_sortable: false,
                b_7700024326226090_rowHeader: false,
                b_7700024326226090_fillEmptyRowSpace: false,
                b_7700024326226090_messages: {
                    msgCreateRow: this.$fn.pgettext("invoiceLines", "New accounting row"),
                },
                b_7700024326226090_columns: null,
            },
        };
    }
    get invoiceLines() {
        if (this.loaded) {
            return this.invoice.lines.data;
        }
        return null;
    }
    get invoiceLineGroups() {
        if (this.loaded) {
            return this.invoice.line_groups.data;
        }
        return null;
    }
    get isIncomingInvoice() {
        if (this.loaded) {
            return this.invoice.invoice_kind == 'incoming';
        }
        return null;
    }
    get isOutgoingInvoice() {
        if (this.loaded) {
            return this.invoice.invoice_kind == 'outgoing';
        }
        return null;
    }
    get invoiceRentalNumber() {
        if (this.loaded) {
            return _.chain(this.invoice.references.data).find({ object: 'rental' }).get('name').value();
        }
        return null;
    }
    async act_1889980785424776_showModal_9094_getActionArgs($event) {
        return {
            name: "UploadInvoiceLines",
            props: {
                invoice: this.invoice,
            },
        };
    }
    async evh_1889980785424776_clickPreventStop(event, scope) {
        return await this.actions.evh_1889980785424776_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_emit_9096_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_5962862420439144_saveCompleted(event, scope) {
        return await this.actions.evh_5962862420439144_saveCompleted.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_script_9098_getActionArgs_value($event) {
        this.invoice.id
            ? $event.data.waitFor(this.$fn.crud('invoice_line').upsert({ ...$event.data.row, invoice_id: this.invoice.id }))
            : this.invoiceLines.splice(this.invoiceLines.length - 1, 0, $event.data.row);
    }
    async act_5962862420439144_script_9098_getActionArgs($event) {
        return {
            value: () => this.act_5962862420439144_script_9098_getActionArgs_value($event),
        };
    }
    async evh_5962862420439144_save(event, scope) {
        return await this.actions.evh_5962862420439144_save.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_script_9102_getActionArgs_value($event) {
        this.onProductSelected($event.parent.data.row, $event.data.modalResult.value);
    }
    async act_5962862420439144_script_9102_getActionArgs($event) {
        return {
            value: () => this.act_5962862420439144_script_9102_getActionArgs_value($event),
        };
    }
    async act_5962862420439144_showModal_9100_getActionArgs($event) {
        return {
            name: "CreateProduct",
            props: {
                preventDefaultOnClose: true,
            },
        };
    }
    async evh_5962862420439144_createProduct(event, scope) {
        return await this.actions.evh_5962862420439144_createProduct.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_script_9104_getActionArgs_value($event) {
        $event.data.waitFor(this.$fn.crud('invoice_line').delete($event.data.row));
    }
    async act_5962862420439144_script_9104_getActionArgs($event) {
        return {
            value: () => this.act_5962862420439144_script_9104_getActionArgs_value($event),
        };
    }
    async evh_5962862420439144_delete(event, scope) {
        return await this.actions.evh_5962862420439144_delete.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_script_9106_getActionArgs_value($event) {
        this.onProductSelected($event.data.row, $event.data.option);
    }
    async act_5962862420439144_script_9106_getActionArgs($event) {
        return {
            value: () => this.act_5962862420439144_script_9106_getActionArgs_value($event),
        };
    }
    async evh_5962862420439144_productSelected(event, scope) {
        return await this.actions.evh_5962862420439144_productSelected.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_script_9108_getActionArgs_value($event) {
        this.invoiceLineHelper.recalculateLineItem($event.data.row, $event.data.field);
    }
    async act_5962862420439144_script_9108_getActionArgs($event) {
        return {
            value: () => this.act_5962862420439144_script_9108_getActionArgs_value($event),
        };
    }
    async evh_5962862420439144_quantityChange(event, scope) {
        return await this.actions.evh_5962862420439144_quantityChange.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_script_9110_getActionArgs_value($event) {
        this.invoiceLineHelper.recalculateLineItem($event.data.row, $event.data.field);
    }
    async act_5962862420439144_script_9110_getActionArgs($event) {
        return {
            value: () => this.act_5962862420439144_script_9110_getActionArgs_value($event),
        };
    }
    async evh_5962862420439144_priceChange(event, scope) {
        return await this.actions.evh_5962862420439144_priceChange.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_script_9112_getActionArgs_value($event) {
        this.invoiceLineHelper.recalculateLineItem($event.data.row, $event.data.field);
    }
    async act_5962862420439144_script_9112_getActionArgs($event) {
        return {
            value: () => this.act_5962862420439144_script_9112_getActionArgs_value($event),
        };
    }
    async evh_5962862420439144_discountChange(event, scope) {
        return await this.actions.evh_5962862420439144_discountChange.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_script_9114_getActionArgs_value($event) {
        this.invoiceLineHelper.recalculateLineItem($event.data.row, $event.data.field);
    }
    async act_5962862420439144_script_9114_getActionArgs($event) {
        return {
            value: () => this.act_5962862420439144_script_9114_getActionArgs_value($event),
        };
    }
    async evh_5962862420439144_netAmountChange(event, scope) {
        return await this.actions.evh_5962862420439144_netAmountChange.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_script_9116_getActionArgs_value($event) {
        this.invoiceLineHelper.recalculateLineItem($event.data.row, $event.data.field);
    }
    async act_5962862420439144_script_9116_getActionArgs($event) {
        return {
            value: () => this.act_5962862420439144_script_9116_getActionArgs_value($event),
        };
    }
    async evh_5962862420439144_amountChange(event, scope) {
        return await this.actions.evh_5962862420439144_amountChange.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_script_9118_getActionArgs_value($event) {
        this.invoiceLineHelper.recalculateLineItem($event.data.row, $event.data.field);
    }
    async act_5962862420439144_script_9118_getActionArgs($event) {
        return {
            value: () => this.act_5962862420439144_script_9118_getActionArgs_value($event),
        };
    }
    async evh_5962862420439144_taxCodeChange(event, scope) {
        return await this.actions.evh_5962862420439144_taxCodeChange.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_script_9120_getActionArgs_value($event) {
        this.onRentalOrPropertySelected($event.data.row, $event.data.option);
    }
    async act_5962862420439144_script_9120_getActionArgs($event) {
        return {
            value: () => this.act_5962862420439144_script_9120_getActionArgs_value($event),
        };
    }
    async evh_5962862420439144_rentalOrPropertySelected(event, scope) {
        return await this.actions.evh_5962862420439144_rentalOrPropertySelected.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_setData_9122_getActionArgs($event) {
        return {
            path: "formContext.selectedInvoiceLines",
            value: $event.data.selection,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_5962862420439144_selectedRowsChanged(event, scope) {
        return await this.actions.evh_5962862420439144_selectedRowsChanged.executeFromDOM(this, event, scope);
    }
    async act_7789867021953041_emit_9124_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_7789867021953041_reload(event, scope) {
        return await this.actions.evh_7789867021953041_reload.executeFromDOM(this, event, scope);
    }
    async act_309515315410323_emit_9128_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_309515315410323_close_9127_getWhen($event) {
        return !!$event.data.modalResult.value;
    }
    async act_309515315410323_showModal_9126_getActionArgs($event) {
        return {
            name: "InvoiceLineGroup",
            props: {
                invoice: this.invoice,
            },
        };
    }
    async evh_309515315410323_clickPreventStop(event, scope) {
        return await this.actions.evh_309515315410323_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_880971572885910_script_9132_getActionArgs_value($event) {
        this.$fn.crud('invoice_line')
            .upsert({
            id: $event.scope.row.id,
            etag: $event.scope.row.etag,
            meter_accounting: {
                invoice_id: this.invoice.id,
                invoice_line_id: $event.scope.row.id,
                ...$event.data.modalResult.value,
            }
        }).then(() => this.$emit('reload'));
    }
    async act_880971572885910_script_9132_getActionArgs($event) {
        return {
            value: () => this.act_880971572885910_script_9132_getActionArgs_value($event),
        };
    }
    async evh_880971572885910_close_9131_getWhen($event) {
        return !!$event.data.modalResult.value;
    }
    async act_880971572885910_showModal_9130_getActionArgs($event) {
        return {
            name: "InvoiceLineMeterReadingSelector",
            props: {
                rental: this.invoiceRentalNumber,
                multiple: false,
                serviceId: $event.scope.row.product ? $event.scope.row.product.id : null,
            },
        };
    }
    async evh_880971572885910_clickPreventStop(event, scope) {
        return await this.actions.evh_880971572885910_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_1803307708030275_script_9134_getActionArgs_value($event) {
        $event.data.waitFor(this.$fn.crud('invoice_line')
            .upsert({
            id: $event.scope.row.id,
            etag: $event.scope.row.etag,
            meter_accounting: $event.data.row,
        }));
    }
    async act_1803307708030275_script_9134_getActionArgs($event) {
        return {
            value: () => this.act_1803307708030275_script_9134_getActionArgs_value($event),
        };
    }
    async evh_1803307708030275_save(event, scope) {
        return await this.actions.evh_1803307708030275_save.executeFromDOM(this, event, scope);
    }
    async act_1803307708030275_emit_9136_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_1803307708030275_saveCompleted(event, scope) {
        return await this.actions.evh_1803307708030275_saveCompleted.executeFromDOM(this, event, scope);
    }
    async act_1803307708030275_script_9138_getActionArgs_value($event) {
        $event.data.waitFor(this.$fn.crud('invoice_line_meter_accounting').delete($event.data.row));
    }
    async act_1803307708030275_script_9138_getActionArgs($event) {
        return {
            value: () => this.act_1803307708030275_script_9138_getActionArgs_value($event),
        };
    }
    async evh_1803307708030275_delete(event, scope) {
        return await this.actions.evh_1803307708030275_delete.executeFromDOM(this, event, scope);
    }
    async act_1803307708030275_emit_9140_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_1803307708030275_deleteCompleted(event, scope) {
        return await this.actions.evh_1803307708030275_deleteCompleted.executeFromDOM(this, event, scope);
    }
    async act_7700024326226090_script_9142_getActionArgs_value($event) {
        $event.data.waitFor(this.$fn.crud('invoice_line_accounting').upsert($event.data.row)
            .then(p => (this.$emit('reload'), p)));
    }
    async act_7700024326226090_script_9142_getActionArgs($event) {
        return {
            value: () => this.act_7700024326226090_script_9142_getActionArgs_value($event),
        };
    }
    async evh_7700024326226090_save(event, scope) {
        return await this.actions.evh_7700024326226090_save.executeFromDOM(this, event, scope);
    }
    async act_7700024326226090_script_9144_getActionArgs_value($event) {
        $event.data.waitFor(this.$fn.crud('invoice_line_accounting').delete($event.data.row));
    }
    async act_7700024326226090_script_9144_getActionArgs($event) {
        return {
            value: () => this.act_7700024326226090_script_9144_getActionArgs_value($event),
        };
    }
    async evh_7700024326226090_delete(event, scope) {
        return await this.actions.evh_7700024326226090_delete.executeFromDOM(this, event, scope);
    }
    async act_7700024326226090_emit_9146_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_7700024326226090_saveCompleted(event, scope) {
        return await this.actions.evh_7700024326226090_saveCompleted.executeFromDOM(this, event, scope);
    }
    async act_7700024326226090_emit_9148_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_7700024326226090_deleteCompleted(event, scope) {
        return await this.actions.evh_7700024326226090_deleteCompleted.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_1889980785424776_showModal_9094 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_1889980785424776_showModal_9094_getActionArgs,
            events: [],
        });
        const evh_1889980785424776_clickPreventStop_9093 = new core_1.actions.EventHandlerImpl({
            action: act_1889980785424776_showModal_9094,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_1889980785424776_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1889980785424776_clickPreventStop_9093],
        });
        const act_5962862420439144_emit_9096 = new core_1.actions.EmitAction({
            actionArgs: this.act_5962862420439144_emit_9096_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_saveCompleted_9095 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_emit_9096,
            event: "save-completed",
            displayName: "emit",
        });
        const evh_5962862420439144_saveCompleted = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_saveCompleted_9095],
        });
        const act_5962862420439144_script_9098 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5962862420439144_script_9098_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_save_9097 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_script_9098,
            event: "save",
            displayName: "script",
        });
        const evh_5962862420439144_save = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_save_9097],
        });
        const act_5962862420439144_script_9102 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5962862420439144_script_9102_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_close_9101 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_script_9102,
            event: "close",
            displayName: "script",
        });
        const act_5962862420439144_showModal_9100 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_5962862420439144_showModal_9100_getActionArgs,
            events: [evh_5962862420439144_close_9101],
        });
        const evh_5962862420439144_createProduct_9099 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_showModal_9100,
            event: "createProduct",
            displayName: "showModal",
        });
        const evh_5962862420439144_createProduct = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_createProduct_9099],
        });
        const act_5962862420439144_script_9104 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5962862420439144_script_9104_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_delete_9103 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_script_9104,
            event: "delete",
            displayName: "script",
        });
        const evh_5962862420439144_delete = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_delete_9103],
        });
        const act_5962862420439144_script_9106 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5962862420439144_script_9106_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_productSelected_9105 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_script_9106,
            event: "product:selected",
            displayName: "script",
        });
        const evh_5962862420439144_productSelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_productSelected_9105],
        });
        const act_5962862420439144_script_9108 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5962862420439144_script_9108_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_quantityChange_9107 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_script_9108,
            event: "quantity:change",
            displayName: "script",
        });
        const evh_5962862420439144_quantityChange = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_quantityChange_9107],
        });
        const act_5962862420439144_script_9110 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5962862420439144_script_9110_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_priceChange_9109 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_script_9110,
            event: "price:change",
            displayName: "script",
        });
        const evh_5962862420439144_priceChange = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_priceChange_9109],
        });
        const act_5962862420439144_script_9112 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5962862420439144_script_9112_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_discountChange_9111 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_script_9112,
            event: "discount:change",
            displayName: "script",
        });
        const evh_5962862420439144_discountChange = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_discountChange_9111],
        });
        const act_5962862420439144_script_9114 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5962862420439144_script_9114_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_netAmountChange_9113 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_script_9114,
            event: "net_amount:change",
            displayName: "script",
        });
        const evh_5962862420439144_netAmountChange = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_netAmountChange_9113],
        });
        const act_5962862420439144_script_9116 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5962862420439144_script_9116_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_amountChange_9115 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_script_9116,
            event: "amount:change",
            displayName: "script",
        });
        const evh_5962862420439144_amountChange = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_amountChange_9115],
        });
        const act_5962862420439144_script_9118 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5962862420439144_script_9118_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_taxCodeChange_9117 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_script_9118,
            event: "tax_code:change",
            displayName: "script",
        });
        const evh_5962862420439144_taxCodeChange = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_taxCodeChange_9117],
        });
        const act_5962862420439144_script_9120 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5962862420439144_script_9120_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_rentalOrPropertySelected_9119 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_script_9120,
            event: "rental_or_property:selected",
            displayName: "script",
        });
        const evh_5962862420439144_rentalOrPropertySelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_rentalOrPropertySelected_9119],
        });
        const act_5962862420439144_setData_9122 = new core_1.actions.SetDataAction({
            actionArgs: this.act_5962862420439144_setData_9122_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_selectedRowsChanged_9121 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_setData_9122,
            event: "selectedRowsChanged",
            displayName: "setData",
        });
        const evh_5962862420439144_selectedRowsChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_selectedRowsChanged_9121],
        });
        const act_7789867021953041_emit_9124 = new core_1.actions.EmitAction({
            actionArgs: this.act_7789867021953041_emit_9124_getActionArgs,
            events: [],
        });
        const evh_7789867021953041_reload_9123 = new core_1.actions.EventHandlerImpl({
            action: act_7789867021953041_emit_9124,
            event: "reload",
            displayName: "emit",
        });
        const evh_7789867021953041_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7789867021953041_reload_9123],
        });
        const act_309515315410323_emit_9128 = new core_1.actions.EmitAction({
            actionArgs: this.act_309515315410323_emit_9128_getActionArgs,
            events: [],
        });
        const evh_309515315410323_close_9127 = new core_1.actions.EventHandlerImpl({
            action: act_309515315410323_emit_9128,
            event: "close",
            when: this.evh_309515315410323_close_9127_getWhen,
            displayName: "emit",
        });
        const act_309515315410323_showModal_9126 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_309515315410323_showModal_9126_getActionArgs,
            events: [evh_309515315410323_close_9127],
        });
        const evh_309515315410323_clickPreventStop_9125 = new core_1.actions.EventHandlerImpl({
            action: act_309515315410323_showModal_9126,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_309515315410323_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_309515315410323_clickPreventStop_9125],
        });
        const act_880971572885910_script_9132 = new core_1.actions.ScriptAction({
            actionArgs: this.act_880971572885910_script_9132_getActionArgs,
            events: [],
        });
        const evh_880971572885910_close_9131 = new core_1.actions.EventHandlerImpl({
            action: act_880971572885910_script_9132,
            event: "close",
            when: this.evh_880971572885910_close_9131_getWhen,
            displayName: "script",
        });
        const act_880971572885910_showModal_9130 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_880971572885910_showModal_9130_getActionArgs,
            events: [evh_880971572885910_close_9131],
        });
        const evh_880971572885910_clickPreventStop_9129 = new core_1.actions.EventHandlerImpl({
            action: act_880971572885910_showModal_9130,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_880971572885910_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_880971572885910_clickPreventStop_9129],
        });
        const act_1803307708030275_script_9134 = new core_1.actions.ScriptAction({
            actionArgs: this.act_1803307708030275_script_9134_getActionArgs,
            events: [],
        });
        const evh_1803307708030275_save_9133 = new core_1.actions.EventHandlerImpl({
            action: act_1803307708030275_script_9134,
            event: "save",
            displayName: "script",
        });
        const evh_1803307708030275_save = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1803307708030275_save_9133],
        });
        const act_1803307708030275_emit_9136 = new core_1.actions.EmitAction({
            actionArgs: this.act_1803307708030275_emit_9136_getActionArgs,
            events: [],
        });
        const evh_1803307708030275_saveCompleted_9135 = new core_1.actions.EventHandlerImpl({
            action: act_1803307708030275_emit_9136,
            event: "save-completed",
            displayName: "emit",
        });
        const evh_1803307708030275_saveCompleted = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1803307708030275_saveCompleted_9135],
        });
        const act_1803307708030275_script_9138 = new core_1.actions.ScriptAction({
            actionArgs: this.act_1803307708030275_script_9138_getActionArgs,
            events: [],
        });
        const evh_1803307708030275_delete_9137 = new core_1.actions.EventHandlerImpl({
            action: act_1803307708030275_script_9138,
            event: "delete",
            displayName: "script",
        });
        const evh_1803307708030275_delete = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1803307708030275_delete_9137],
        });
        const act_1803307708030275_emit_9140 = new core_1.actions.EmitAction({
            actionArgs: this.act_1803307708030275_emit_9140_getActionArgs,
            events: [],
        });
        const evh_1803307708030275_deleteCompleted_9139 = new core_1.actions.EventHandlerImpl({
            action: act_1803307708030275_emit_9140,
            event: "delete-completed",
            displayName: "emit",
        });
        const evh_1803307708030275_deleteCompleted = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1803307708030275_deleteCompleted_9139],
        });
        const act_7700024326226090_script_9142 = new core_1.actions.ScriptAction({
            actionArgs: this.act_7700024326226090_script_9142_getActionArgs,
            events: [],
        });
        const evh_7700024326226090_save_9141 = new core_1.actions.EventHandlerImpl({
            action: act_7700024326226090_script_9142,
            event: "save",
            displayName: "script",
        });
        const evh_7700024326226090_save = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7700024326226090_save_9141],
        });
        const act_7700024326226090_script_9144 = new core_1.actions.ScriptAction({
            actionArgs: this.act_7700024326226090_script_9144_getActionArgs,
            events: [],
        });
        const evh_7700024326226090_delete_9143 = new core_1.actions.EventHandlerImpl({
            action: act_7700024326226090_script_9144,
            event: "delete",
            displayName: "script",
        });
        const evh_7700024326226090_delete = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7700024326226090_delete_9143],
        });
        const act_7700024326226090_emit_9146 = new core_1.actions.EmitAction({
            actionArgs: this.act_7700024326226090_emit_9146_getActionArgs,
            events: [],
        });
        const evh_7700024326226090_saveCompleted_9145 = new core_1.actions.EventHandlerImpl({
            action: act_7700024326226090_emit_9146,
            event: "save-completed",
            displayName: "emit",
        });
        const evh_7700024326226090_saveCompleted = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7700024326226090_saveCompleted_9145],
        });
        const act_7700024326226090_emit_9148 = new core_1.actions.EmitAction({
            actionArgs: this.act_7700024326226090_emit_9148_getActionArgs,
            events: [],
        });
        const evh_7700024326226090_deleteCompleted_9147 = new core_1.actions.EventHandlerImpl({
            action: act_7700024326226090_emit_9148,
            event: "delete-completed",
            displayName: "emit",
        });
        const evh_7700024326226090_deleteCompleted = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7700024326226090_deleteCompleted_9147],
        });
        return {
            act_1889980785424776_showModal_9094,
            evh_1889980785424776_clickPreventStop_9093,
            evh_1889980785424776_clickPreventStop,
            act_5962862420439144_emit_9096,
            evh_5962862420439144_saveCompleted_9095,
            evh_5962862420439144_saveCompleted,
            act_5962862420439144_script_9098,
            evh_5962862420439144_save_9097,
            evh_5962862420439144_save,
            act_5962862420439144_script_9102,
            evh_5962862420439144_close_9101,
            act_5962862420439144_showModal_9100,
            evh_5962862420439144_createProduct_9099,
            evh_5962862420439144_createProduct,
            act_5962862420439144_script_9104,
            evh_5962862420439144_delete_9103,
            evh_5962862420439144_delete,
            act_5962862420439144_script_9106,
            evh_5962862420439144_productSelected_9105,
            evh_5962862420439144_productSelected,
            act_5962862420439144_script_9108,
            evh_5962862420439144_quantityChange_9107,
            evh_5962862420439144_quantityChange,
            act_5962862420439144_script_9110,
            evh_5962862420439144_priceChange_9109,
            evh_5962862420439144_priceChange,
            act_5962862420439144_script_9112,
            evh_5962862420439144_discountChange_9111,
            evh_5962862420439144_discountChange,
            act_5962862420439144_script_9114,
            evh_5962862420439144_netAmountChange_9113,
            evh_5962862420439144_netAmountChange,
            act_5962862420439144_script_9116,
            evh_5962862420439144_amountChange_9115,
            evh_5962862420439144_amountChange,
            act_5962862420439144_script_9118,
            evh_5962862420439144_taxCodeChange_9117,
            evh_5962862420439144_taxCodeChange,
            act_5962862420439144_script_9120,
            evh_5962862420439144_rentalOrPropertySelected_9119,
            evh_5962862420439144_rentalOrPropertySelected,
            act_5962862420439144_setData_9122,
            evh_5962862420439144_selectedRowsChanged_9121,
            evh_5962862420439144_selectedRowsChanged,
            act_7789867021953041_emit_9124,
            evh_7789867021953041_reload_9123,
            evh_7789867021953041_reload,
            act_309515315410323_emit_9128,
            evh_309515315410323_close_9127,
            act_309515315410323_showModal_9126,
            evh_309515315410323_clickPreventStop_9125,
            evh_309515315410323_clickPreventStop,
            act_880971572885910_script_9132,
            evh_880971572885910_close_9131,
            act_880971572885910_showModal_9130,
            evh_880971572885910_clickPreventStop_9129,
            evh_880971572885910_clickPreventStop,
            act_1803307708030275_script_9134,
            evh_1803307708030275_save_9133,
            evh_1803307708030275_save,
            act_1803307708030275_emit_9136,
            evh_1803307708030275_saveCompleted_9135,
            evh_1803307708030275_saveCompleted,
            act_1803307708030275_script_9138,
            evh_1803307708030275_delete_9137,
            evh_1803307708030275_delete,
            act_1803307708030275_emit_9140,
            evh_1803307708030275_deleteCompleted_9139,
            evh_1803307708030275_deleteCompleted,
            act_7700024326226090_script_9142,
            evh_7700024326226090_save_9141,
            evh_7700024326226090_save,
            act_7700024326226090_script_9144,
            evh_7700024326226090_delete_9143,
            evh_7700024326226090_delete,
            act_7700024326226090_emit_9146,
            evh_7700024326226090_saveCompleted_9145,
            evh_7700024326226090_saveCompleted,
            act_7700024326226090_emit_9148,
            evh_7700024326226090_deleteCompleted_9147,
            evh_7700024326226090_deleteCompleted,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcInvoiceLines.prototype, "invoice", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoice'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceLines.prototype, "onInvoice", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcInvoiceLines.prototype, "currency", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('currency'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceLines.prototype, "onCurrency", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Number,
    }),
    __metadata("design:type", Number)
], UcInvoiceLines.prototype, "defaultDiscount", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('defaultDiscount'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceLines.prototype, "onDefault_discount", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], UcInvoiceLines.prototype, "defaultTaxCode", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('defaultTaxCode'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceLines.prototype, "onDefault_tax_code", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcInvoiceLines.prototype, "formContext", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('formContext'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceLines.prototype, "onForm_context", null);
UcInvoiceLines = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcInvoiceLines);
exports.default = UcInvoiceLines;
vue_property_decorator_1.Vue.component("UcInvoiceLines", UcInvoiceLines);
